import {format, isFuture, isPast, isToday} from 'date-fns'

export function cn (...args) {
  return args.filter(Boolean).join(' ')
}

export function mapEdgesToNodes (data) {
  if (!data.edges) return []
  return data.edges.map(edge => edge.node)
}

export function filterOutDocsWithoutSlugs ({slug}) {
  return (slug || {}).current
}

export function filterOutDocsPublishedInTheFuture ({publishedAt}) {
  return !isFuture(publishedAt)
}

export function filterOutExpiredDocs ({validTo}) {
  return !validTo || isToday(validTo) || !isPast(validTo)
}

export function filterOutNotPublishedDocs({validFrom}) {
  return !validFrom || isToday(validFrom) || !isFuture(validFrom)
}

export function getBlogUrl (publishedAt, slug) {
  return `/blog/${format(publishedAt, 'YYYY/MM')}/${slug.current || slug}/`
}

export function buildImageObj (source) {
  const imageObj = {
    asset: {_ref: source.asset._ref || source.asset._id}
  }

  if (source.crop) imageObj.crop = source.crop
  if (source.hotspot) imageObj.hotspot = source.hotspot

  return imageObj
}

export function lengthIsOdd (arr) {
  return Math.abs(arr.length % 2) == 1;
}

export function documentIsActive(edge) {
  return 
}